import type { QuotingPortal } from 'lib/hosts/quoting/interface';
import { Undef } from 'types/UtilityTypes';

export const InsightTMSSubmitAction = 'insight-tms-submit-quote';

export function isInsightTMSUrl(urlStr: Undef<string>): boolean {
  if (!urlStr) return false;

  try {
    const url = new URL(urlStr);
    return (
      url.hostname.toLowerCase().endsWith('.mercurygate.net') &&
      url.pathname.toLowerCase().includes('/mercurygate/')
    );
  } catch {
    return false;
  }
}

export class InsightTMS implements QuotingPortal {
  submitAction = InsightTMSSubmitAction;

  canSubmit(tab: Undef<chrome.tabs.Tab>, _html: string): boolean {
    return isInsightTMSUrl(tab?.url);
  }
}
